// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bcbt[data-v-1a846390]{font-size:14px;font-weight:400}a.bcbt[data-v-1a846390]{text-decoration:underline;--text-opacity:1;color:#6366f1;color:rgba(99,102,241,var(--text-opacity))}", ""]);
// Exports
module.exports = exports;
